module.exports = __webpack_public_path__ + "426b692218ccbcccc2f0f3641a9071d5.png";